/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Activity_Center_Embedding_ErrorsInputs */



/**
* | output |
* | --- |
* | "{count} errors" |
*
* @param {Activity_Center_Embedding_ErrorsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_center_embedding_errors = /** @type {((inputs: Activity_Center_Embedding_ErrorsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Center_Embedding_ErrorsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Fehler`)
	return /** @type {LocalizedString} */ (`${i?.count} errors`)
});